// ContactPage.js
import React from 'react';

const ContactPage = () => {
  return (
    <div>
      <p>Let's connect! Here's how you can reach me:</p>
      
      <div style={{ margin: '20px 0' }}>
        <h3>Professional Links</h3>
        <p>
          <strong>LinkedIn:</strong> <a href="https://www.linkedin.com/in/gillian-bryson/" target="_blank" rel="noopener noreferrer" style={{ color: '#ADDAEF' }}>linkedin.com/in/gillian-bryson</a><br/>
          <strong>GitHub:</strong> <a href="https://github.com/BusinessGoose001" target="_blank" rel="noopener noreferrer" style={{ color: '#ADDAEF' }}>github.com/BusinessGoose001</a><br/>
          <strong>Email:</strong> <a href="mailto:gillian@example.com" style={{ color: '#ADDAEF' }}>gillian@example.com</a>
        </p>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>What I'm Looking For</h3>
        <p>I'm interested in backend development opportunities, especially roles involving:</p>
        <ul style={{ paddingLeft: '20px' }}>
          <li>Data pipeline development and ETL/ELT processes</li>
          <li>Internal tooling and automation</li>
          <li>Cloud infrastructure and DevOps practices</li>
          <li>API development and system integration</li>
        </ul>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h3>Let's Chat</h3>
        <p>Whether you're looking for a developer, want to collaborate on a project, or just want to talk about data pipelines and automation, I'd love to hear from you!</p>
      </div>
    </div>
  );
};

export default ContactPage;